<template>
  <div>
    <el-dialog
    class="all-enterprise-table"
    :visible.sync="show"
    :before-close="close"
    destroy-on-close
    :modal="false"
    >
      <div slot="title">
        <span class="title">所有入驻企业</span>
        <span class="num">已入驻{{totalCount}}家企业</span>
      </div>
      <div>
        <el-table
        :max-height="$remToPx(5)"
        border
        :data="tableData"
        >
          <template v-for="(item, index) in tableColumns">
            <el-table-column
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :formatter="item.formatter"
            :width="item.width"/>
          </template>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCount"
          class="paginationBody">
      </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      pageSize: 10,
      currentPage: 1,
      tableColumns: [
        {
          prop: 'createTime',
          label: '入驻时间',
          formatter: (row) => {
            return row.createTime ? row.createTime.substring(0, 10) : ''
          },
          width: this.$remToPx(1.4)
        },
        {
          prop: 'renterCompanyName',
          label: '入驻企业名称'
        },
        {
          prop: 'businessType',
          label: '所属产业',
          width: this.$remToPx(2)
        }
      ]
    }
  },
  props: {
    coList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    tableData () {
      // 后端一次性返回 前端分页 无奈
      let coList = this.coList || []
      return coList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    totalCount () {
      return this.coList?.length || 0
    }
  },
  methods: {
    close () {
      this.show = false
    },
    showDetails () {
      this.show = true
      this.getData()
    },
    handleCurrentChange (page) {
      this.currentPage = page
    }
  }
}
</script>

<style lang="scss" scoped>
.all-enterprise-table {
  /deep/ .el-dialog {
    min-width: 500px;
    width: 40% !important;
    background: linear-gradient(to left, rgba(38,69,97,0.8), rgba(39,71,98, 0.8));
    .el-dialog__header {
      border-bottom: 0.01rem solid #6b7986;
      .el-dialog__close {
        font-size: 0.2rem;
      }
      .title {
        font-size: 0.15rem;
        color: #E9F5FF;
        margin-right: 0.3rem;
      }
      .num {
        color: #1EE7E7;
        font-size: 0.12rem;
      }
    }
  }
  /deep/ .el-table {
    &::after, &::before{
      background-color: #10495E;
    }
    border-color: #10495E;
    border-width: 0.01rem;
    background-color: transparent;
    .el-table__header {
      tr {
        background-color: transparent;
      }
      th {
        background: rgba($color: #0F2B45, $alpha: 0.5) !important;
        color: #DBEFFF;
        font-size: 0.2rem;
        line-height: 0.4rem;
        border-bottom: 0.01rem solid #10495E;
        border-right: 0.01rem solid #10495E;
        .cell {
          line-height: 0.4rem;
        }
      }
    }
    .el-table__body {
      tr {
        background-color: transparent;
        td {
          border-bottom: 0.01rem solid #10495E;
          border-right: 0.01rem solid #10495E;
          color: #DBEFFF;
          font-size: 0.2rem;
          line-height: 0.3rem;
          .cell {
            line-height: 0.3rem;
          }
        }
      }
      th {
        background: rgba($color: #1E3C58, $alpha: 0.3) !important;
        color: #DBEFFF;
      }
      &:hover {
        td {
          background-color: transparent;
        }
      }
    }
  }
  /deep/ .el-pagination {
    margin-top: 0.2rem;
    text-align: center;
    button {
      background: #122C43;
      color: #9C9C9C;
      height: 0.37rem;
      width: 0.5rem;
      line-height: 0.37rem;
      .el-icon {
        font-size: 0.2rem;
      }
    }
    .el-pager {
      .number {
        background: #122C43;
        color: #9C9C9C;
        font-size: 0.2rem;
        height: 0.37rem;
        width: 0.5rem;
        line-height: 0.37rem;
      }
      .active {
        background: #134F63;
        color: #FFFFFF;
      }
    }
  }
}
</style>